import { createApiClients } from '@kanbios/api-client';

/** Typed clients generated from the plugins' OpenAPI schemas (ADR-004). */
export const api = createApiClients();

export interface ApiErrorBody {
  code: string;
  message: string;
  hint: string;
  requestId: string;
  details?: Record<string, unknown>;
}

/** A refused or failed call, carrying the backend's own sentence and remedy. */
export class ApiFailure extends Error {
  constructor(readonly status: number, readonly body: ApiErrorBody, readonly url = '') {
    super(body.message || `HTTP ${status} ${url}`);
  }
  /** No backend error body: the failure came from in between (dev proxy, network, gateway). */
  get beforeBackend(): boolean {
    return !this.body.requestId;
  }
}

function isErrorBody(value: unknown): value is ApiErrorBody {
  return typeof value === 'object' && value !== null && 'code' in value && 'message' in value;
}

/** Unwraps an openapi-fetch result; any non-2xx becomes an ApiFailure. */
export function unwrap<T>(result: { data?: T; error?: unknown; response: Response }): T {
  // A 204 has no body: it succeeded all the same (writing a secret answered « an error » without a message).
  if (result.response.ok) return result.data as T;
  const body = isErrorBody(result.error)
    ? result.error
    : { code: 'INTERNAL_ERROR', message: '', hint: '', requestId: result.response.headers.get('X-Request-Id') ?? '' };
  throw new ApiFailure(result.response.status, body, result.response.url);
}

export const isAuthFailure = (e: unknown) => e instanceof ApiFailure && e.status === 401;

/** The engine's own reason behind a failure (GitHub, Scaffolder…), when the backend gives one. */
export const causeOf = (f: ApiFailure | null | undefined): string | null => {
  const cause = f?.body.details?.cause;
  return typeof cause === 'string' && cause ? cause : null;
};
